import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import NextLink from "next/link";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Button } from "@/components/ui/Button";
import { Hero, type HeroTextPosition } from "@/components/ui/sections/Hero";
import type { HeroStoryblok } from "@/generated/sb/sb-types";
import { sbLink } from "@/lib/storyblok/link";

export const HeroBlok = ({
	blok,
	isHeader,
}: BlokProps<HeroStoryblok> & {
	isHeader?: boolean;
}) => {
	const primaryHref = sbLink(blok.primaryActionLink)?.href;
	const secondaryHref = sbLink(blok.secondaryActionLink)?.href;
	const textPosition = (blok.textPosition ?? "center") as HeroTextPosition;

	const actions =
		blok.primaryActionLabel || blok.secondaryActionLabel ? (
			<>
				{blok.primaryActionLabel && primaryHref && (
					<Button as={NextLink} href={primaryHref} color="primary" variant="solid" size="large">
						{blok.primaryActionLabel}
					</Button>
				)}
				{blok.secondaryActionLabel && secondaryHref && (
					<Button as={NextLink} href={secondaryHref} color="secondary" variant="solid" size="large">
						{blok.secondaryActionLabel}
					</Button>
				)}
			</>
		) : null;

	return (
		<BlokWrap editable={blok} className={clsx(!isHeader && "pb-grid-section-vertical-md")}>
			<Hero
				assets={[blok.primaryAsset, blok.secondaryAsset]}
				caption={blok.caption || undefined}
				title={blok.title || undefined}
				description={blok.description || undefined}
				countdownTo={blok.countdownTo || undefined}
				actions={actions}
				textPosition={textPosition}
				fullWidth={Boolean(blok.fullWidth)}
				priority
				isHeader={isHeader}
			/>
		</BlokWrap>
	);
};
